import { finish, error } from '../../../modules/payments/actions/query';
import api from '../../../api';
import { uniq } from 'lodash';

export function request(dispatch, { query }) {
    const q = {
        perPage: 10,
        aggregations: {
            total: {
                type: 'count'
            }
        }
    };

    if (query.page) {
        q.page = query.page;
    }

    if (query.perPage) {
        q.perPage = query.perPage;
    }

    const types = {};

    // Don't include any bonus subTypes if 'Bonus' is not selected in 'Transaction Type'
    if (query['enabledTransactionTypes'].includes('bonus')) {

        // Get bonuses types from data that is sent from the form
        // Example of data bonus item: bonus[best-odds-guaranteed]
        // Extract the value from squared brackeds and create and array
        // with bonus types e.g. ['best-odds-guaranded', 'lucky-all-winner', ...]
        const bonuses = Object.keys(query)
            .filter(b => b.startsWith('bonus[') && query[b])
            .map(b => b.slice(6, -1));

        if (bonuses.length > 0) {
            q['tagsType'] = bonuses;
        }
    }

    if (query['enabledTransactionTypes'].includes('reward')) {

        const rewards = Object.keys(query)
            .filter(b => b.startsWith('reward[') && query[b])
            .map(b => b.slice(7, -1));

        if (rewards.length > 0) {
            q['tagsType'] = rewards;
        }
    }

    //deposits
    const deposits = Object.keys(query)
        .filter(v => v.startsWith('deposit[') && query[v])
        .map(v => v.slice(8, -1));

    if (deposits.length > 0) {
        types.deposit = [];
        deposits.forEach(statuses => types.deposit = types.deposit.concat(statuses.split('.')));
    }

    //withdrawals
    const withdrawals = Object.keys(query)
        .filter(v => v.startsWith('withdrawal[') && query[v])
        .map(v => v.slice(11, -1));

    if (withdrawals.length > 0) {
        types.withdrawal = [];
        withdrawals.forEach(statuses => types.withdrawal = types.withdrawal.concat(statuses.split('.')));
    }

    //adjustment
    const adjustment = Object.keys(query)
        .filter(v => v.startsWith('adjustment[') && query[v])
        .map(v => v.slice(11, -1));

    if (adjustment.length > 0) {
        types.adjustment = adjustment;
    }

    //manual
    const manual = Object.keys(query)
        .filter(v => v.startsWith('manual[') && query[v])
        .map(v => v.slice(7, -1));

    if (manual.length > 0) {
        types.manual = manual;
    }

    //casino
    const casino = Object.keys(query)
    .filter(v => v.startsWith('casino[') && query[v])
    .map(v => v.slice(7, -1));

    if (casino.length > 0) {
        types.casino = casino;
    }

    //provider
    const provider = Object.keys(query)
        .filter(v => v.startsWith('provider[') && query[v])
        .map(v => v.slice(9, -1));

    if (provider.length > 0) {
        q.provider = provider;
    }

    //date range
    if (query.range) {
        const dateRange = {
            gte: query.range.startDate,
            lte: query.range.endDate
        };
        q.createdAt = dateRange;
    }

    //amount range
    if (query.amount) {
        q.amount = {};

        if (query.amount.start) {
            q.amount.gte = parseInt(query.amount.start * 100, 10);
        }

        if (query.amount.end) {
            q.amount.lte = parseInt(query.amount.end * 100, 10);
        }
    }

    //account ID
    if (query['account-id']) {
        q['account'] = query['account-id'];
    }

    //transaction types
    if (query['transaction-types'] === 'withdrawal') {
        delete types.deposit;
    } else if (query['transaction-types'] === 'deposit') {
        delete types.withdrawal;
    }

    //add summary
    if (query.summary) {
        q.aggregations = {
            total: {
                type: 'count'
            },
            totalValue: {
                type: 'sum',
                field: 'amount'
            }
        };
    }

    //save report
    if (query.save) {
        q.saveReport = true;
    }
    q.types = types;

    q.enabledTransactionTypes = query.enabledTransactionTypes;

    api.post('/payments', q).then(
        ({ results, aggregations }) => dispatch(finish(results, aggregations)),
        ({ errors }) => dispatch(error(errors))
    );
}
